var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertLevel3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132.29 132.29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alertLevel3_svg__a",
    x1: 1109.4,
    x2: 1109.5,
    y1: 98.463,
    y2: 26.458,
    gradientTransform: "translate(-1674.4 -31.523) scale(1.5669)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7971e",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7981e",
    offset: 0.017
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbb415",
    offset: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcdf2f",
    offset: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcef89",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.75 114.44c-1.924 4.65-6.966 7.847-10.902 7.847H20.312c-6.07 0-10.715-1.56-14.161-6.366-3.447-4.806-4.803-10.466 2.077-22.271C24.63 65.509 47.02 26.209 48.234 24.523 50.14 21.875 55.27 9.999 65.47 9.999c10.2 0 13.99 7.687 17.856 14.572 2.494 4.44 25.428 43.683 41.071 71.183 5.463 9.602 5.278 14.037 3.353 18.687z",
    fill: "url(#alertLevel3_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.007 95.75a7.12 7.12 0 01-7.12 7.119 7.12 7.12 0 01-7.119-7.12 7.12 7.12 0 017.12-7.12 7.12 7.12 0 017.119 7.12zM74.887 44.571c0 4.857-.384 39.591-8.794 39.591-8.707 0-8.795-34.735-8.795-39.59s3.938-8.795 8.795-8.795a8.794 8.794 0 018.794 8.794z"
  })));
}
export default SvgAlertLevel3;